import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const Card = ({ title, rows }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-4">
    <div className="heading-font font-semibold text-slate-800 mb-2">{title}</div>
    <div className="divide-y divide-slate-100">
      {rows.length === 0 && <div className="text-sm text-slate-500 py-2">No data.</div>}
      {rows.map(r => (
        <div key={r.name} className="flex items-center justify-between py-2 text-sm">
          <span className="text-slate-600">{r.name}</span>
          <span className="font-semibold text-slate-900">{r.count}</span>
        </div>
      ))}
    </div>
  </div>
);

export default function LeadsManagement() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/leads/mgmt/dashboard").then(r=>setD(r.data)); }, []);
  if (!d) return <div className="text-slate-500">Loading…</div>;

  const kpi = [
    ["Total Leads", d.totals.leads, "text-slate-900"],
    ["Retained", d.totals.retained, "text-emerald-600"],
    ["Retained This Month", d.totals.retained_this_month, "text-emerald-600"],
    ["Dead / Unresponsive", d.totals.dead, "text-slate-500"],
    ["Conversion Rate", `${d.totals.conversion_rate_pct}%`, "text-blue-600"],
    ["Avg First-Response", d.totals.avg_first_response_hours!=null ? `${d.totals.avg_first_response_hours}h` : "—", "text-amber-600"],
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="heading-font text-3xl font-bold text-slate-900">Lead Management — Reporting</h1>
        <p className="text-sm text-slate-500 mt-1">Sales-funnel health across sources, callers, and outcomes</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {kpi.map(([label, val, cls]) => (
          <div key={label} className="bg-white rounded-xl border border-slate-200 p-4">
            <div className="text-xs uppercase text-slate-500">{label}</div>
            <div className={`heading-font text-2xl font-bold mt-1 ${cls}`}>{val}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card title="Leads by Source" rows={d.by_source}/>
        <Card title="Leads by File Type" rows={d.by_type}/>
        <Card title="Leads by Caller" rows={d.by_caller}/>
        <Card title="Leads by Stage" rows={d.by_stage}/>
        <Card title="Lost Reasons" rows={d.lost_reasons}/>
        <Card title="Overdue Follow-Ups by Employee" rows={d.overdue_by_employee}/>
      </div>
    </div>
  );
}
